module.exports = __webpack_public_path__ + "img/planetGalaxyIcon.61cf2bdb.webp";